export default "__VITE_ASSET__3vzBrtVH__"